import { getFormattedVersion } from "@/config/version";

interface VersionDisplayProps {
  /**
   * Variante de estilo do componente
   * - "default": texto cinza escuro
   * - "muted": texto cinza claro/discreto
   * - "badge": estilo de badge/distintivo
   */
  variant?: "default" | "muted" | "badge";

  /**
   * Tamanho do texto
   */
  size?: "sm" | "md" | "lg";

  /**
   * Alinhamento do texto
   */
  align?: "left" | "center" | "right";

  /**
   * Classes CSS adicionais
   */
  className?: string;

  /**
   * Se true, adiciona "v" antes da versão
   */
  withPrefix?: boolean;
}

export const VersionDisplay = ({
  variant = "default",
  size = "sm",
  align = "center",
  className = "",
  withPrefix = true,
}: VersionDisplayProps) => {
  const version = getFormattedVersion(withPrefix);

  const variantClasses = {
    default: "text-gray-600 dark:text-gray-400",
    muted: "text-gray-400 dark:text-gray-500",
    badge: "bg-primary/10 text-primary px-2 py-1 rounded-md font-medium",
  };

  const sizeClasses = {
    sm: "text-xs",
    md: "text-sm",
    lg: "text-base",
  };

  const alignClasses = {
    left: "text-left",
    center: "text-center",
    right: "text-right",
  };

  return (
    <div
      className={`${variantClasses[variant]} ${sizeClasses[size]} ${alignClasses[align]} ${className}`}
    >
      {version}
    </div>
  );
};
